/**
 * Date-extensions locale Georgian [ka]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ka', {
    monthNames: ['იანვარი','თებერვალი','მარტი','აპრილი','მაისი','ივნისი','ივლისი','აგვისტო','სექტემბერი','ოქტომბერი','ნოემბერი','დეკემბერი'],
    monthShortNames: ['იან','თებ','მარ','აპრ','მაი','ივნ','ივლ','აგვ','სექ','ოქტ','ნოე','დეკ'],
    dayNames: ['კვირა','ორშაბათი','სამშაბათი','ოთხშაბათი','ხუთშაბათი','პარასკევი','შაბათი'],
    dayShortNames: ['კვი','ორშ','სამ','ოთხ','ხუთ','პარ','შაბ']
});
